/** Resolved by Vite at build time; overridden in Jest via `setupTests.ts`. */
export function getSupportAppDownloadUrl(): string {
  return import.meta.env.VITE_SUPPORT_APP_DOWNLOAD;
}
